import { LightLoginUpgradeRespone } from '@msc-b2c/interfaces/interfaces';
import { LoginMode } from '@msc-b2c/interfaces/enums';

export const lightLoginUpgradeResponseMockMyMsc: LightLoginUpgradeRespone = {
  token: 'eyJhbGciOiJIUzI1NiIsIn',
  loginMode: LoginMode.LIGHT,
  bookingNumber: '12345',
  passengerId: '1',
  cruiseId: 'EU20241018BCNBCN',
};
